import styled from 'styled-components';

export const teste = styled.div`
  background-color: blue;
`;

export const BotaoHamburguer = styled.button`
  border: none;
  outline: none;
  background-color: none;
  cursor: pointer;
  display: none;

  svg {
    height: 24px;
    width: 24px;
    fill: #333;
    margin-right: 10px;
  }

  :hover {
    svg {
      fill: #2a7ae2;
    }
  }

  @media screen and (max-width: 800px) {
    display: block;
    position: absolute;
    right: 0;
  }
`;
